<template lang="pug">
transition(name="fade")
  .popup(v-if="popupShow")
    ul.inner
      li(:class="{'is-current' : (IsCurrent('Top'))}")
        a(@click="LinkTo('Top')") Top
      li(:class="{'is-current' : (IsCurrent('Shampoo'))}")
        a(@click="LinkTo('Shampoo')") Shampoo
      li(:class="{'is-current' : (IsCurrent('Menu'))}")
        a(@click="LinkTo('Menu')") Menu
      li(:class="{'is-current' : (IsCurrent('Concept'))}")
        a(@click="LinkTo('Concept')") Concept
      li(:class="{'is-current' : (IsCurrent('Voice'))}")
        a(@click="LinkTo('Voice')") Voice
      li(:class="{'is-current' : (IsCurrent('Access'))}")
        a(@click="LinkTo('Access')") Access
      li(:class="{'is-current' : (IsCurrent('Reserve'))}")
        a(@click="LinkTo('Reserve')") Reserve
</template>

<script>
export default {
  props: ['popupShow'],
  computed: {
    isPopupShow:{
      get: function() {
        return this.popupShow
      },
      set: function(value) {
        this.$emit('update-popupshow', value)
      }
    }
  },
  methods:{
    LinkTo: function(urlName) {
      if (this.IsCurrent(urlName)) {
        return
      }

      this.isPopupShow = false
      this.$router.push({
        name: urlName
      })
      sessionStorage.setItem('positionY', 0)
    },
    IsCurrent: function(urlName) {
      return this.$route.name === urlName
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes fade-in {
  0% {
    opacity: 0.7;
    width: 100%;
    left: 10%;
  }
  100% {
    opacity: 0.8;
    width: 100%;
    left: 0;
  }
}

@keyframes fade-out {
  0% {
    opacity: 0.8;
    width: 100%;
    left: 0;
  }
  100% {
    opacity: 0;
    width: 0;
    left: -100%;
  }
}

@keyframes text-slide-up {
  0% {
    transform: scale(1,0);
  }
  100% {
    transform: scale(1,1);
  }
}

.fade-enter-active {
  animation: fade-in .5s;
}
.fade-leave-active {
  animation: fade-out .5s;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 100;
  opacity: 0.8;
  animation-fill-mode: forwards;
  > .inner {
    margin-top: 100px;
    line-height: 40px;
  }
  li {
    font-size: 18px;
    &.is-current {
      > a {
        font-weight: bold;
      }
    }
    > a {
      text-decoration: none;
      display: block;
      transform: scale(1,0);
      transform-origin: center bottom;
      animation: text-slide-up 0.5s;
      animation-fill-mode: forwards;
      animation-delay: 0.3s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue